import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { QuickReplyMessageType } from "services/sendbird/quick-reply-messages/fetch-quick-reply-message-api"

export interface DeleteQuickReplyMessageResponseData extends AxiosResponse {
  data: QuickReplyMessageType
  message: string
}
export interface DeleteQuickReplyMessageResponse extends AxiosResponse {
  data: DeleteQuickReplyMessageResponseData
}

export interface DeleteQuickReplyMessageRequestData {
  pmcId: string
  quickReplyMessageId: number
}
export interface DeleteQuickReplyMessageRequest
  extends Partial<AxiosRequestConfig> {
  params: DeleteQuickReplyMessageRequestData
}

const defaultUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/sendbird/delete-quick-reply-message`

export function deleteQuickReplyMessageApi(
  {
    params,
    method = "delete",
    url = `${defaultUrl}`,
    ...config
  }: DeleteQuickReplyMessageRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<DeleteQuickReplyMessageResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<DeleteQuickReplyMessageResponse>
}
